import * as React from 'react';
import { IStringLocalizer } from '../../../utilities/IStringLocalizer';
import { useLocalizer } from './hooks/useLocalizer';
import { AIHeader } from './AIHeader';
import { AITryAgainButton } from './AITryAgainButton';
import { AIUploadDifferentFilesButton } from './AIUploadDifferentFilesButton';
import { UploadedFile } from './types';
import { DataCollectionAiAgentOperationType } from '../../../store/Models/Surveys/SurveyDataModel';

const terminatedMessageIconSrc = "/images/supplier-ai-agent/failure-message-icon.svg";

interface AITerminatedStateProps {
    requestId?: string;
    operationId?: string;
    uploadedFiles: UploadedFile[];
    operationType: DataCollectionAiAgentOperationType;
    onClearError?: () => void;
    onError?: (message: string) => void;
    localizer?: IStringLocalizer;
    errorMessage?: string;
}

export const AITerminatedState: React.FC<AITerminatedStateProps> = ({
    requestId,
    operationId,
    uploadedFiles,
    operationType,
    onClearError,
    onError,
    localizer,
    errorMessage
}) => {
    const localize = useLocalizer(localizer);
    const defaultMessage = localize("This AI request was automatically terminated by Exchange due to agent inactivity.");

    return (
        <>
            <div>
                <AIHeader localizer={localizer} />
            </div>
            <div className="ai-failure-container ai-terminated-container">
                <div className="ai-terminated-status-row" role="status" aria-live="polite">
                    <span className="glyphicon glyphicon-remove-circle ai-terminated-status-icon-inline" aria-hidden="true"></span>
                    <span className="ai-terminated-status-text">{localize("Terminated")}</span>
                </div>

                <div className="ai-failure-message-box ai-terminated-message-box">
                    <div className="ai-failure-message-icon">
                        <img
                            src={terminatedMessageIconSrc}
                            width="20"
                            height="20"
                            className="ai-terminated-message-icon"
                            aria-hidden="true"
                            alt=""
                        />
                    </div>
                    <div className="ai-failure-message-content">
                        <p className="ai-failure-message-text">
                            {errorMessage || defaultMessage}
                        </p>
                    </div>
                </div>

                <div className="ai-failure-button-container">
                    <AITryAgainButton
                        requestId={requestId}
                        operationId={operationId}
                        uploadedFiles={uploadedFiles}
                        operationType={operationType}
                        onClearError={onClearError}
                        onError={onError}
                        localizer={localizer}
                        className="ai-try-again-button-terminated"
                    />
                    <AIUploadDifferentFilesButton
                        onError={onError}
                        localizer={localizer}
                    />
                </div>
            </div>
        </>
    );
};

export default AITerminatedState;
